import "@hotwired/turbo-rails"
import "./controllers"

console.log("Application JS loaded - v2.0");
